import {MediaQueries} from 'vue-media-queries';
export const mediaQueries = new MediaQueries();
